<template>
    <g>
        <countDown ref="countDown1" name="cd1" />
        <countDown ref="countDown2" name="cd2" />
        <transition name="quickfade">
            <g v-if="condition == 'RP' || condition == 'Mat'">
                <rect
                    stroke="#00000020"
                    stroke-width="10"
                    fill="#FFFFFF88"
                    x="-300"
                    y="-420"
                    width="600"
                    height="110"
                    rx="15"
                />
                <text
                    opacity="1.0"
                    x="60"
                    y="-330"
                    class="txt"
                    text-anchor="end"
                    dominant-baseline="auto"
                    font-family="sans-serif"
                    font-size="96"
                    fill="#000000CC"
                    >{{ question }}</text
                >
                <text
                    opacity="1.0"
                    x="100"
                    y="-330"
                    class="txt"
                    text-anchor="start"
                    dominant-baseline="auto"
                    font-family="sans-serif"
                    font-size="96"
                    fill="#000000CC"
                    >{{ answer }}</text
                >
            </g>
        </transition>
        <transition name="quickfade">
            <g v-if="condition == 'RP'">
                <g
                    v-for="(v, idx) in button_pos"
                    :key="idx"
                    v-on:click="btn_click(idx)"
                    v-on:mouseover="btn_mouse_over(idx)"
                    v-on:mouseleave="btn_mouse_leave(idx)"
                >
                    <rect
                        stroke="#00000020"
                        stroke-width="5"
                        :fill="btn_colour(idx)"
                        :x="v.x * 110 - 47"
                        :y="v.y * 110 - 47 + 50"
                        width="95"
                        height="95"
                        rx="15"
                    />
                    <text
                        :x="v.x * 110"
                        :y="v.y * 110 + 56"
                        class="txt"
                        text-anchor="middle"
                        dominant-baseline="middle"
                        font-family="sans-serif"
                        font-size="50"
                        fill="#FFFFFF"
                        >{{ idx }}</text
                    >
                </g>
                <g v-on:click="click_ok()">
                    <rect
                        stroke="#00000020"
                        stroke-width="5"
                        :fill="btn_ok_colour()"
                        x="190"
                        y="-80"
                        width="120"
                        height="120"
                        rx="15"
                    />
                    <text
                        x="250"
                        y="-17"
                        class="txt"
                        text-anchor="middle"
                        dominant-baseline="middle"
                        font-family="sans-serif"
                        font-size="40"
                        fill="#FFFFFF"
                        >OK</text
                    >
                </g>
                <g v-on:click="click_erase()">
                    <rect
                        stroke="#00000020"
                        stroke-width="5"
                        :fill="btn_erase_colour()"
                        x="190"
                        y="60"
                        width="120"
                        height="120"
                        rx="15"
                    />
                    <text
                        x="247"
                        y="123"
                        class="txt"
                        text-anchor="middle"
                        dominant-baseline="middle"
                        font-family="sans-serif"
                        font-size="40"
                        fill="#FFFFFF"
                        >⌫</text
                    >
                </g>
                <g v-if="item_feedback">
                    <g
                        v-if="feedback_response_correct"
                        opacity="1.0"
                        transform="scale(4.4, 4.4) translate(-90, -75)"
                    >
                        <path
                            d="M 99 74 C 138 75 138 75 109 96 C 119 130 119 130 90 110 C 61 130 61 130 71 96 C 42 75 42 75 78 74 C 90 40 90 40 102 74"
                            stroke="#00000022"
                            stroke-width="8"
                            fill="#FFCC66"
                        />
                        <path
                            d="M 78 74 C 90 40 90 40 102 74 C 138 75 138 75 109 96"
                            stroke="none"
                            fill="#FFFFAA2C"
                        />
                        <path
                            d="M 90 110 C 61 130 61 130 71 96 C 42 75 42 75 78 74"
                            stroke="none"
                            fill="#0000000C"
                        />
                    </g>
                    <circle v-else cx="0" cy="55" r="120" fill="#FF333388" />
                    <text
                        opacity="1.0"
                        x="0"
                        y="90"
                        class="txt"
                        text-anchor="middle"
                        dominant-baseline="auto"
                        font-family="sans-serif"
                        font-size="96"
                        fill="#000000DD"
                        >{{ this.current_x * this.current_y }}</text
                    >
                </g>
            </g>
        </transition>

        <transition name="quickfade">
            <g v-if="condition == 'Mat'">
                <g v-for="(vy, iy) in 12" :key="iy">
                    <g
                        v-for="(vx, ix) in 12"
                        :key="ix"
                        v-on:click="mat_click(vx, vy)"
                        v-on:mouseover="mat_mouse_over(vx, vy)"
                        v-on:mouseleave="mat_mouse_leave(vx, vy)"
                    >
                        <rect
                            stroke="#00000020"
                            stroke-width="3"
                            :fill="mat_colour(vx, vy)"
                            :x="ix * 64 - 360 - 20"
                            :y="iy * 60 - 260 - 20"
                            width="60"
                            height="55"
                            rx="5"
                        />
                        <text
                            :x="ix * 64 - 351"
                            :y="iy * 60 - 250"
                            class="txt"
                            text-anchor="middle"
                            dominant-baseline="middle"
                            font-family="sans-serif"
                            font-size="32"
                            fill="#FFFFFF"
                            >{{ vx * vy }}</text
                        >
                        <!-- mat_colour(vx, vy) -->
                        <!-- {{ vx * vy }} -->
                    </g>
                </g>
                <g v-if="item_feedback">
                    <g
                        v-if="feedback_response_correct"
                        opacity="1.0"
                        :transform="
                            'scale(1.2, 1.2) translate(' +
                            String(-433 + this.current_x * 53) +
                            ',' +
                            String(-350 + this.current_y * 50) +
                            ')'
                        "
                    >
                        <path
                            d="M 99 74 C 138 75 138 75 109 96 C 119 130 119 130 90 110 C 61 130 61 130 71 96 C 42 75 42 75 78 74 C 90 40 90 40 102 74"
                            stroke="#00000022"
                            stroke-width="8"
                            fill="#FFCC66"
                        />
                        <path
                            d="M 78 74 C 90 40 90 40 102 74 C 138 75 138 75 109 96"
                            stroke="none"
                            fill="#FFFFAA2C"
                        />
                        <path
                            d="M 90 110 C 61 130 61 130 71 96 C 42 75 42 75 78 74"
                            stroke="none"
                            fill="#0000000C"
                        />
                    </g>
                    <circle
                        v-else
                        :cx="-414 + this.current_x * 64"
                        :cy="-312 + this.current_y * 60"
                        r="35"
                        fill="#FF333388"
                    />
                    <text
                        :x="-415 + this.current_x * 64"
                        :y="-310 + this.current_y * 60"
                        class="txt"
                        text-anchor="middle"
                        dominant-baseline="middle"
                        font-family="sans-serif"
                        font-size="32"
                        fill="#000000"
                        >{{ this.current_x * this.current_y }}</text
                    >
                    <g v-if="!pilot">
                        <g
                            v-if="feedback_response_correct"
                            opacity="1.0"
                            :transform="
                                'scale(1.2, 1.2) translate(' +
                                String(-433 + this.current_y * 53) +
                                ',' +
                                String(-350 + this.current_x * 50) +
                                ')'
                            "
                        >
                            <path
                                d="M 99 74 C 138 75 138 75 109 96 C 119 130 119 130 90 110 C 61 130 61 130 71 96 C 42 75 42 75 78 74 C 90 40 90 40 102 74"
                                stroke="#00000022"
                                stroke-width="8"
                                fill="#FFCC66"
                            />
                            <path
                                d="M 78 74 C 90 40 90 40 102 74 C 138 75 138 75 109 96"
                                stroke="none"
                                fill="#FFFFAA2C"
                            />
                            <path
                                d="M 90 110 C 61 130 61 130 71 96 C 42 75 42 75 78 74"
                                stroke="none"
                                fill="#0000000C"
                            />
                        </g>
                        <circle
                            v-else
                            :cx="-414 + this.current_y * 64"
                            :cy="-312 + this.current_x * 60"
                            r="35"
                            fill="#FF333388"
                        />
                        <text
                            :x="-415 + this.current_y * 64"
                            :y="-310 + this.current_x * 60"
                            class="txt"
                            text-anchor="middle"
                            dominant-baseline="middle"
                            font-family="sans-serif"
                            font-size="32"
                            fill="#000000"
                            >{{ this.current_x * this.current_y }}</text
                        >
                    </g>
                </g>
            </g>
        </transition>
        <transition name="quickfade">
            <g v-if="condition == 'SelfEfficacy'">
                <foreignObject x="-400" y="-400" width="800" height="900">
                    <div v-if="self_effq == 1" class="qtopic">
                        Hur säker är du att du kunde största delen av
                        uppgifterna?
                    </div>
                    <div v-else-if="self_effq == 2" class="qtopic">
                        Hur säker är du att du svarade rätt på största delen av
                        uppgifterna?
                    </div>

                    <div v-if="self_effq == 1 || self_effq == 2">
                        <br />
                        <div
                            class="qbutton"
                            style="background-color: #ffffff33"
                            v-on:click="log_self_efficacy(1)"
                        >
                            1. Väldigt osäker
                        </div>
                        <br />
                        <div
                            class="qbutton"
                            style="background-color: #ffffff33"
                            v-on:click="log_self_efficacy(2)"
                        >
                            2. Ganska osäker
                        </div>
                        <br />
                        <div
                            class="qbutton"
                            style="background-color: #ffffff33"
                            v-on:click="log_self_efficacy(3)"
                        >
                            3. Ganska säker
                        </div>
                        <br />
                        <div
                            class="qbutton"
                            style="background-color: #ffffff33"
                            v-on:click="log_self_efficacy(4)"
                        >
                            4. Helt säker
                        </div>
                    </div>
                </foreignObject>
            </g>
        </transition>
        <transition name="quickfade">
            <g v-if="cog_done">
                <rect
                    stroke="#000000ff"
                    stroke-width="3"
                    fill="#FFFFFFCC"
                    x="-240"
                    y="-280"
                    width="484"
                    height="100"
                    rx="5"
                />
                <text
                    x="0"
                    y="-230"
                    class="txt"
                    text-anchor="middle"
                    dominant-baseline="middle"
                    font-family="sans-serif"
                    font-size="30"
                    fill="#000000FF"
                    >Klart för den här gången!</text
                >
            </g>
        </transition>
    </g>
</template>

<script>
import { store } from "@/store.js";
import persist from "@/persist.js";
import countDown from "@/v/countDown2.vue";
import * as cards from "./cards.js";
import stat from "@/stat.js";

/*const set_a = [{"x":2,"y":4},{"x":2,"y":6},{"x":2,"y":8},{"x":2,"y":10},{"x":2,"y":12},{"x":3,"y":3},{"x":3,"y":5},{"x":3,"y":7},{"x":3,"y":9},{"x":3,"y":11},{"x":4,"y":2},{"x":4,"y":4},{"x":4,"y":6},{"x":4,"y":8},{"x":4,"y":10},{"x":4,"y":12},{"x":5,"y":3},{"x":5,"y":5},{"x":5,"y":7},{"x":5,"y":9},{"x":5,"y":11},{"x":6,"y":2},{"x":6,"y":4},{"x":6,"y":6},{"x":6,"y":8},{"x":6,"y":10},{"x":6,"y":12},{"x":7,"y":3},{"x":7,"y":5},{"x":7,"y":7},{"x":7,"y":9},{"x":7,"y":11},{"x":8,"y":2},{"x":8,"y":4},{"x":8,"y":6},{"x":8,"y":8},{"x":8,"y":10},{"x":8,"y":12},{"x":9,"y":3},{"x":9,"y":5},{"x":9,"y":7},{"x":9,"y":9},{"x":9,"y":11},{"x":10,"y":2},{"x":10,"y":4},{"x":10,"y":6},{"x":10,"y":8},{"x":10,"y":10},{"x":10,"y":12},{"x":11,"y":3},{"x":11,"y":5},{"x":11,"y":7},{"x":11,"y":9},{"x":11,"y":11},{"x":12,"y":2},{"x":12,"y":4},{"x":12,"y":6},{"x":12,"y":8},{"x":12,"y":10},{"x":12,"y":12}];

const set_b = [{"x":2,"y":3},{"x":2,"y":5},{"x":2,"y":7},{"x":2,"y":9},{"x":2,"y":11},{"x":3,"y":2},{"x":3,"y":4},{"x":3,"y":6},{"x":3,"y":8},{"x":3,"y":10},{"x":3,"y":12},{"x":4,"y":3},{"x":4,"y":5},{"x":4,"y":7},{"x":4,"y":9},{"x":4,"y":11},{"x":5,"y":2},{"x":5,"y":4},{"x":5,"y":6},{"x":5,"y":8},{"x":5,"y":10},{"x":5,"y":12},{"x":6,"y":3},{"x":6,"y":5},{"x":6,"y":7},{"x":6,"y":9},{"x":6,"y":11},{"x":7,"y":2},{"x":7,"y":4},{"x":7,"y":6},{"x":7,"y":8},{"x":7,"y":10},{"x":7,"y":12},{"x":8,"y":3},{"x":8,"y":5},{"x":8,"y":7},{"x":8,"y":9},{"x":8,"y":11},{"x":9,"y":2},{"x":9,"y":4},{"x":9,"y":6},{"x":9,"y":8},{"x":9,"y":10},{"x":9,"y":12},{"x":10,"y":3},{"x":10,"y":5},{"x":10,"y":7},{"x":10,"y":9},{"x":10,"y":11},{"x":11,"y":2},{"x":11,"y":4},{"x":11,"y":6},{"x":11,"y":8},{"x":11,"y":10},{"x":11,"y":12},{"x":12,"y":3},{"x":12,"y":5},{"x":12,"y":7},{"x":12,"y":9},{"x":12,"y":11}];
*/

function getDayOfYear(date) {
    const start = new Date(date.getFullYear(), 0, 0);
    const diff = date - start;
    const oneDay = 1000 * 60 * 60 * 24;
    const day = Math.floor(diff / oneDay);
    return day;
}

var session_results = {
    rp_rts: [],
    rp_corr_rts: [],
    rp_err_rts: [],
    //
    mat_rts: [],
    mat_corr_rts: [],
    mat_err_rts: [],
};

//var mouse_used = false;

var mat_cross_timeout = 0;
var ok_btn_timeout = 0;

export default {
    name: "choke_practice_multiplication",
    //props: ['stim_param'],
    //mixins: [lang],
    computed: {
        text() {
            return 0;
            //return this.getLocalisedText();
        },
        button_pos() {
            return [
                { x: 0, y: 2 },
                { x: -1, y: -1 },
                { x: 0, y: -1 },
                { x: 1, y: -1 },
                { x: -1, y: 0 },
                { x: 0, y: 0 },
                { x: 1, y: 0 },
                { x: -1, y: 1 },
                { x: 0, y: 1 },
                { x: 1, y: 1 },
            ];
        },
    },
    data: () => {
        return {
            start_time: 0,
            show_buttons: true,
            input_disabled: false,
            items: [],
            condition: "",
            btn_ok_down: false,
            btn_erase_down: false,
            btn_hover: -1,
            question: "",
            answer: "",
            mat_hover: [-1, -1],
            show_mat_answer: false,
            current_x: 1,
            current_y: 1,
            rp_deck: [],
            mat_deck: [],
            rp_set: "",
            mat_set: "",
            item_feedback: false,
            item_start_time: 0,
            feedback_response_correct: false,
            pract_length: 0,
            session_score: 0,
            crossover: 0,
            beforeUnloadHandler: null,
            initial_session: 0,
            pilot: false,
            cog_done: false, // dagens kogtest klara?
            day: 0,
            self_effq: 0,
            self_eff_res1: 0,
            self_eff_res2: 0,
        };
    },
    methods: {
        btn_mouse_over(idx) {
            if (this.input_disabled) return;
            this.btn_hover = idx;
        },
        btn_mouse_leave(idx) {
            if (this.btn_hover == idx) this.btn_hover = -1;
        },
        btn_click(idx) {
            if (this.input_disabled) return;
            if (this.answer.length == 0 && idx == 0) return;

            if (
                this.answer.length < 2 ||
                (this.answer.length == 2 && this.answer[0] == "1")
            ) {
                this.answer = this.answer + idx;
                //this.$set(this.btn_state, idx, true);
                //setTimeout(() => {
                //  this.$set(this.btn_state, idx, false);
                //}, 100);
            }
        },
        click_ok() {
            if (this.input_disabled) return;
            this.input_disabled = true;

            if (!this.btn_ok_down) {
                this.btn_ok_down = true;
                clearTimeout(ok_btn_timeout);
                ok_btn_timeout = setTimeout(() => {
                    this.btn_ok_down = false;
                }, 100);
                var corr = this.answer == this.current_x * this.current_y;
                this.feedback_response_correct = corr;

                this.item_feedback = true;
                setTimeout(() => {
                    this.item_feedback = false;
                    this.log_rp_response();
                }, 2000);
            }
        },
        click_erase() {
            if (this.input_disabled) return;

            if (!this.btn_erase_down) {
                if (this.answer.length > 0) {
                    this.answer = this.answer.substring(
                        0,
                        this.answer.length - 1
                    );

                    this.btn_erase_down = true;
                    setTimeout(() => {
                        this.btn_erase_down = false;
                    }, 100);
                }
            }
        },
        new_rp_item() {
            if (this.condition != "RP") return;
            this.item_feedback = false;
            //console.log("new_rp_item() ---");
            this.item_start_time = Date.now();
            var item = cards.get_current_item(this.rp_deck, this.rp_set);
            this.current_x = item.x;
            this.current_y = item.y;
            this.question = item.y + "·" + item.x + " =";
            this.answer = "";
            this.show_mat_answer = false;
            this.input_disabled = false;
            clearTimeout(mat_cross_timeout);
            clearTimeout(ok_btn_timeout);
        },
        new_mat_item() {
            if (this.condition != "Mat") return;
            this.item_feedback = false;
            this.item_start_time = Date.now();
            var item = cards.get_current_item(this.mat_deck, this.mat_set);
            this.current_x = item.x;
            this.current_y = item.y;
            this.question = item.y + "·" + item.x + " =";

            this.answer = item.x * item.y;
            this.show_mat_answer = false;
            clearTimeout(mat_cross_timeout);
            mat_cross_timeout = setTimeout(() => {
                if (this.condition == "Mat") {
                    this.show_mat_answer = true;
                }
            }, 10000);
            this.input_disabled = false;
            clearTimeout(ok_btn_timeout);
        },
        mat_colour(vx, vy) {
            if (this.mat_hover[0] == vx && this.mat_hover[1] == vy) {
                return "#FF777788";
            }
            if (this.show_mat_answer == false) {
                if (vx == 1 || vy == 1) {
                    return "#77777722";
                } else {
                    return "#777777FF";
                }
            } else {
                if (this.pilot) {
                    if (vx == 1 || vy == 1) {
                        if (vx == this.current_x || vy == this.current_y) {
                            return "#77CC77FF";
                        } else {
                            return "#77777722";
                        }
                    } else {
                        if (vx == this.current_x && vy == this.current_y) {
                            return "#88DD88FF";
                        } else if (
                            vx == this.current_x ||
                            vy == this.current_y
                        ) {
                            return "#778477FF";
                        } else {
                            return "#777777FF";
                        }
                    }
                } else {
                    if (vx == 1 || vy == 1) {
                        if (
                            vx == this.current_x ||
                            vy == this.current_y ||
                            vx == this.current_y ||
                            vy == this.current_x
                        ) {
                            return "#00005522";
                        } else {
                            return "#77777722";
                        }
                    } else {
                        if (
                            (vx == this.current_x && vy == this.current_y) ||
                            (vx == this.current_y && vy == this.current_x)
                        ) {
                            return "#88DD88FF";
                        } else if (
                            (vx == this.current_x && vy < this.current_y) ||
                            (vx == this.current_y && vy < this.current_x) ||
                            (vx < this.current_x && vy == this.current_y) ||
                            (vx < this.current_y && vy == this.current_x)
                        ) {
                            return "#777788FF";
                        } else {
                            return "#777777FF";
                        }
                    }
                }
            }
        },
        mat_mouse_over(vx, vy) {
            if (vx > 1 && vy > 1) this.mat_hover = [vx, vy];
        },
        mat_mouse_leave(vx, vy) {
            if (this.mat_hover[0] == vx && this.mat_hover[1] == vy) {
                this.mat_hover = [-1, -1];
            }
        },
        mat_click(vx, vy) {
            if (this.input_disabled) return;
            this.log_mat_response(vx, vy);
        },
        // mat_mousedown(vx, vy) {
        //  if (this.input_disabled) return;
        //  this.log_mat_response(vx, vy, true);
        // },
        // mat_mouseup() {},
        // mat_touchstart(vx, vy, event) {
        //  if (event) {
        //      event.preventDefault();
        //  }
        //  if (this.input_disabled) return;
        //  this.log_mat_response(vx, vy, false);
        // },
        // mat_touchend(event) {
        //  if (event) {
        //      event.preventDefault();
        //  }
        // },
        //log_mat_response(vx, vy, mouse_tap) {
        log_mat_response(vx, vy) {
            this.input_disabled = true;

            //var rt = ((Date.now() - this.item_start_time) / 1000.0).toFixed(3);
            var rt = stat.xround((Date.now() - this.item_start_time) / 1000.0);
            var corr = vx * vy == this.current_x * this.current_y;
            this.feedback_response_correct = corr;
            this.item_feedback = true;

            /*console.log(
                "log: " +
                    this.condition +
                    ", " +
                    mouse_tap +
                    ", " +
                    vx +
                    "·" +
                    vy +
                    ", corr: " +
                    corr +
                    ", rt: " +
                    rt
            );*/
            //mouse_used |= mouse_tap;
            session_results.mat_rts.push(rt);
            if (corr) session_results.mat_corr_rts.push(rt);
            else session_results.mat_err_rts.push(rt);
            cards.update(this.mat_deck, corr, rt);

            setTimeout(() => {
                this.item_feedback = false;
                this.new_mat_item();
            }, 2000);
        },
        log_rp_response() {
            //var rt = ((Date.now() - this.item_start_time) / 1000.0).toFixed(3);
            var rt = stat.xround((Date.now() - this.item_start_time) / 1000.0);
            var corr = this.answer == this.current_x * this.current_y;
            /*console.log(
                "log rp: " + this.answer + ", corr: " + corr + ", rt: " + rt
            );*/

            session_results.rp_rts.push(rt);
            if (corr) session_results.rp_corr_rts.push(rt);
            else session_results.rp_err_rts.push(rt);
            cards.update(this.rp_deck, corr, rt);

            this.new_rp_item();
        },
        btn_ok_colour() {
            if (this.answer.length == 0) return "#66BB6622";
            return this.btn_ok_down ? "#99EE99FF" : "#66BB66FF";
        },
        btn_erase_colour() {
            if (this.answer.length == 0) return "#BB666622";
            return this.btn_erase_down ? "#EE9999FF" : "#BB6666FF";
        },
        btn_colour(idx) {
            if (
                this.answer.length == 3 ||
                (this.answer.length == 2 && this.answer[0] != "1")
            )
                return "#77777722";

            //if (this.btn_down == idx) return "#ccccff99";
            //else
            if (this.btn_hover == idx) return "#FF777788";
            else return "#77777788";
        },
        end_test() {
            this.condition = "Result";
            this.question = "";
            this.answer = "";
            this.item_feedback = false;
            this.input_disabled = true;
            this.show_buttons = false;

            this.saveSessionResults();
            window.removeEventListener(
                "beforeunload",
                this.beforeUnloadHandler
            );
            if (this.pilot) {
                this.show_score();
            } else {
                if (
                    this.initial_session == 2 ||
                    this.initial_session == 9 ||
                    this.initial_session == 11 ||
                    this.initial_session == 18
                ) {
                    this.show_self_efficacy();
                } else {
                    this.show_score();
                }
            }
        },
        show_self_efficacy() {
            this.condition = "SelfEfficacy";
            this.self_effq = 1;
            this.self_eff_res1 = 0;
            this.self_eff_res2 = 0;
        },
        log_self_efficacy(alt) {
            if (this.self_effq == 1) {
                this.self_effq = 0;
                this.self_eff_res1 = alt;
                setTimeout(() => {
                    this.self_effq = 2;
                }, 200);
            } else if (this.self_effq == 2) {
                this.self_effq = 0;
                this.condition = "Result";
                this.self_eff_res2 = alt;

                const grp = this.$store.state.progress.grp || 0;

                persist.log("self_efficacy", {
                    time: Date.now(),
                    s: this.initial_session,
                    crossover: this.crossover,
                    rp: this.rp_set,
                    mat: this.mat_set,
                    grp: grp,
                    day: this.day,
                    resp1: this.self_eff_res1,
                    resp2: this.self_eff_res2,
                });

                this.show_score();
            }
        },
        end_self_efficacy() {
            this.show_score();
        },
        show_score() {
            persist
                .addToHistory("score", this.session_score)
                .then((history) => {
                    store.commit("setSessionScores", history);
                    store.commit("setTaskMode", "sessionScore");
                });
        },
        abortAndSave() {
            this.saveSessionResults();
        },
        saveSessionResults() {
            const total_time = Date.now() - this.start_time;

            var num_rp_corr = session_results.rp_corr_rts.length;
            var num_rp_err = session_results.rp_err_rts.length;
            var num_rp = session_results.rp_rts.length;

            var num_mat_corr = session_results.mat_corr_rts.length;
            var num_mat_err = session_results.mat_err_rts.length;
            var num_mat = session_results.mat_rts.length;

            const [rp_rt_median, rp_rt_mad] =
                stat.mut_array_median_absolute_deviation(
                    session_results.rp_rts
                );

            const [rp_corr_rt_median, rp_corr_rt_mad] =
                stat.mut_array_median_absolute_deviation(
                    session_results.rp_corr_rts
                );

            const [rp_err_rt_median, rp_err_rt_mad] =
                stat.mut_array_median_absolute_deviation(
                    session_results.rp_err_rts
                );

            const [mat_rt_median, mat_rt_mad] =
                stat.mut_array_median_absolute_deviation(
                    session_results.mat_rts
                );

            const [mat_corr_rt_median, mat_corr_rt_mad] =
                stat.mut_array_median_absolute_deviation(
                    session_results.mat_corr_rts
                );

            const [mat_err_rt_median, mat_err_rt_mad] =
                stat.mut_array_median_absolute_deviation(
                    session_results.mat_err_rts
                );

            //const session = this.$store.state.progress.session || 1;
            //persist.set_progress_data("session", session + 1);

            let session = this.initial_session;
            if (total_time > 20000) {
                // 20 sekunder
                persist.set_progress_data("session", this.initial_session + 1);
            }

            const grp = this.$store.state.progress.grp || 0;

            var first_cond = "";
            var second_cond = "";

            var rp_state_name = "rpx";
            var mat_state_name = "matx";

            if (this.crossover == 0) {
                if (grp == 0) {
                    first_cond = "RP";
                    second_cond = "Mat";
                    rp_state_name = "rpa";
                    mat_state_name = "matb";
                } else if (grp == 1) {
                    first_cond = "RP";
                    second_cond = "Mat";
                    rp_state_name = "rpb";
                    mat_state_name = "mata";
                } else if (grp == 2) {
                    first_cond = "Mat";
                    second_cond = "RP";
                    rp_state_name = "rpa";
                    mat_state_name = "matb";
                } else if (grp == 3) {
                    first_cond = "Mat";
                    second_cond = "RP";
                    rp_state_name = "rpb";
                    mat_state_name = "mata";
                }
            } else {
                // crossover sessions
                if (grp == 0) {
                    first_cond = "RP";
                    second_cond = "Mat";
                    rp_state_name = "rpb";
                    mat_state_name = "mata";
                } else if (grp == 1) {
                    first_cond = "RP";
                    second_cond = "Mat";
                    rp_state_name = "rpa";
                    mat_state_name = "matb";
                } else if (grp == 2) {
                    first_cond = "Mat";
                    second_cond = "RP";
                    rp_state_name = "rpb";
                    mat_state_name = "mata";
                } else if (grp == 3) {
                    first_cond = "Mat";
                    second_cond = "RP";
                    rp_state_name = "rpa";
                    mat_state_name = "matb";
                }
            }

            let saved_rp = cards.save_deck(this.rp_deck, session);
            let saved_mat = cards.save_deck(this.mat_deck, session);
            persist.set_progress_data(rp_state_name, saved_rp);
            persist.set_progress_data(mat_state_name, saved_mat);

            //console.log("Saved RP:");
            //console.log(JSON.stringify(saved_rp));
            //console.log("Saved Mat:");
            //console.log(JSON.stringify(saved_mat));

            persist.log("results", {
                start_time: this.start_time,
                total_time: Math.trunc(total_time),
                s: session,
                //touch: mouse_used ? 0 : 1,
                //-- retrieval practice
                rp_rt: rp_rt_median,
                rp_rt_mad: rp_rt_mad,
                rp_c_rt: rp_corr_rt_median,
                rp_c_rt_mad: rp_corr_rt_mad,
                rp_e_rt: rp_err_rt_median,
                rp_e_rt_mad: rp_err_rt_mad,
                n_rp: num_rp,
                n_rp_c: num_rp_corr,
                n_rp_e: num_rp_err,
                //-- matrix
                mat_rt: mat_rt_median,
                mat_rt_mad: mat_rt_mad,
                mat_c_rt: mat_corr_rt_median,
                mat_c_rt_mad: mat_corr_rt_mad,
                mat_e_rt: mat_err_rt_median,
                mat_e_rt_mad: mat_err_rt_mad,
                n_mat: num_mat,
                n_mat_c: num_mat_corr,
                n_mat_e: num_mat_err,
                //--
                len: this.pract_length,
                crossover: this.crossover,
                rp: this.rp_set,
                mat: this.mat_set,
                ord: first_cond + second_cond,
                day: this.day,
            });

            this.session_score = num_mat_corr + num_rp_corr;
        },
        setup() {
            store.commit("setTaskMode", "playing");
            //store.commit('setTaskMode', 'readyImmediateInstruct');
            //store.commit("setTaskMode", "ready_no_exit");
            store.commit("taskPhase", 0);
            this.$parent.show_buttons = false;
        },
        start_rp_set() {
            this.condition = "RP";
            this.new_rp_item();
        },
        start_mat_set() {
            this.condition = "Mat";
            this.new_mat_item();
        },
    },
    components: {
        countDown,
    },
    mounted() {
        const session = this.$store.state.progress.session || 0;
        //console.log("session: " + session);
        const cogtest_session = 0;
        const pretest_session = 1;

        const abs_day = getDayOfYear(new Date());
        const first_day = this.$store.state.progress.first_day || abs_day;
        const rel_day = abs_day - first_day;
        //console.log("Idag är det dag: ", abs_day);
        //console.log("Första dagen: ", first_day);
        //console.log("Relativ dag: ", rel_day);
        this.day = rel_day;

        const config = this.$store.state.progress.conf || "";
        const pilot = config == "reb";
        this.pilot = pilot;
        //console.log("pilot? " + pilot);

        // ändra även default i test_multiplication:
        if (this.$store.state.progress.mid_session == null) {
            persist.set_progress_data("mid_session", 10);
        }
        const midtest_session = this.$store.state.progress.mid_session;

        if (this.$store.state.progress.post_session == null) {
            persist.set_progress_data("post_session", 19);
        }
        const posttest_session = this.$store.state.progress.post_session;

        if (this.$store.state.progress.grp == null) {
            persist.set_progress_data("grp", 0);
        }
        const grp = this.$store.state.progress.grp;

        // Session 0: kog
        // Session 1: test multiplication
        // Session 2+: practice multiplication
        // Session mid: test multiplication
        // Session mid+: practice multiplication
        // Session post: test multiplication

        if (session == cogtest_session) {
            const bgid = this.$store.state.progress.bgid || null;
            //const test_wisc4_mat = this.$store.state.progress.mat || 0;
            //const test_2 = this.$store.state.progress.mat || 0;
            //console.log("test_wisc4_mat: " + test_wisc4_mat);
            const done_spatial = this.$store.state.progress.spatial || 0;
            //const done_letters = this.$store.state.progress.letters || 0;
            const done_math = this.$store.state.progress.math || 0;
            const done_digits = this.$store.state.progress.digits || 0;

            if (bgid == null) {
                store.dispatch("gotoModule", "choke_bgid");
            } else if (done_spatial != 1) {
                store.dispatch("gotoModule", "test_span_spatial_linear");
            } else if (done_math != 1) {
                store.dispatch("gotoModule", "test_operation_span_math");
            } else if (done_digits != 1) {
                store.dispatch("gotoModule", "test_span_digits");
            } else {
                persist.set_progress_data("first_day", first_day);
                // TODO: message
                persist.set_progress_data("session", cogtest_session + 1);
                //store.commit("setTaskMode", "sessionDone");
                store.commit("setTaskMode", "clickToExit");
                this.cog_done = true;
            }
            return;
        }

        if (session == pretest_session) {
            store.dispatch("gotoModule", "choke_test_multiplication");
            return;
        }

        if (session == midtest_session) {
            store.dispatch("gotoModule", "choke_test_multiplication");
            return;
        }

        if (session == posttest_session) {
            store.dispatch("gotoModule", "choke_test_multiplication");
            return;
        }

        const anxforms_done = this.$store.state.progress.anxforms_done || 0;
        //console.log("anxforms_done: " + anxforms_done);
        /*if (pilot) {
            if (session > midtest_session && anxforms_done == 0) {
                store.dispatch("gotoModule", "choke_anxform");
                return;
            }
            if (session > posttest_session && anxforms_done < 2) {
                store.dispatch("gotoModule", "choke_anxform");
                return;
            }
        } else {*/
        if (!pilot) {
            if (session > pretest_session && anxforms_done == 0) {
                store.dispatch("gotoModule", "choke_anxform");
                return;
            }
            if (session > midtest_session && anxforms_done == 1) {
                store.dispatch("gotoModule", "choke_anxform");
                return;
            }
            if (session > posttest_session && anxforms_done < 3) {
                store.dispatch("gotoModule", "choke_anxform");
                return;
            }
        }

        if (session > posttest_session) {
            // TODO: message
            //store.commit("setTaskMode", "clickToExit");
            store.commit("setTaskMode", "sessionDone");
            return;
        }

        var saved_rp;
        var saved_mat;

        var session_since_test;
        var first_cond; // RP eller MAT
        var second_cond; // RP eller MAT
        if (session < midtest_session) {
            session_since_test = session - pretest_session;
            this.crossover = 0;

            if (grp == 0) {
                first_cond = "RP";
                second_cond = "Mat";
                this.rp_set = "A";
                this.mat_set = "B";
                saved_rp = this.$store.state.progress.rpa || null;
                saved_mat = this.$store.state.progress.matb || null;
            } else if (grp == 1) {
                first_cond = "RP";
                second_cond = "Mat";
                this.rp_set = "B";
                this.mat_set = "A";
                saved_rp = this.$store.state.progress.rpb || null;
                saved_mat = this.$store.state.progress.mata || null;
            } else if (grp == 2) {
                first_cond = "Mat";
                second_cond = "RP";
                this.rp_set = "A";
                this.mat_set = "B";
                saved_rp = this.$store.state.progress.rpa || null;
                saved_mat = this.$store.state.progress.matb || null;
            } else if (grp == 3) {
                first_cond = "Mat";
                second_cond = "RP";
                this.rp_set = "B";
                this.mat_set = "A";
                saved_rp = this.$store.state.progress.rpb || null;
                saved_mat = this.$store.state.progress.mata || null;
            }
        } else {
            // crossover sessions
            session_since_test = session - midtest_session;
            this.crossover = 1;

            if (grp == 0) {
                first_cond = "RP";
                second_cond = "Mat";
                this.rp_set = "B";
                this.mat_set = "A";
                saved_rp = this.$store.state.progress.rpb || null;
                saved_mat = this.$store.state.progress.mata || null;
            } else if (grp == 1) {
                first_cond = "RP";
                second_cond = "Mat";
                this.rp_set = "A";
                this.mat_set = "B";
                saved_rp = this.$store.state.progress.rpa || null;
                saved_mat = this.$store.state.progress.matb || null;
            } else if (grp == 2) {
                first_cond = "Mat";
                second_cond = "RP";
                this.rp_set = "B";
                this.mat_set = "A";
                saved_rp = this.$store.state.progress.rpb || null;
                saved_mat = this.$store.state.progress.mata || null;
            } else if (grp == 3) {
                first_cond = "Mat";
                second_cond = "RP";
                this.rp_set = "A";
                this.mat_set = "B";
                saved_rp = this.$store.state.progress.rpa || null;
                saved_mat = this.$store.state.progress.matb || null;
            }
        }
        const pract_length = Math.min(
            270,
            Math.max(60, 90 + session_since_test * 30)
        ); // max 3,5 minuter
        this.pract_length = pract_length;

        // init rp deck
        if (saved_rp == null) {
            //console.log("new rp deck");
            this.rp_deck = cards.new_deck();
        } else {
            //console.log("loading saved rp deck");
            this.rp_deck = cards.load_deck(saved_rp);
        }

        // init mat deck
        if (saved_mat == null) {
            //console.log("new mat deck");
            this.mat_deck = cards.new_deck();
        } else {
            //console.log("loading saved mat deck");
            this.mat_deck = cards.load_deck(saved_mat);
        }

        this.setup();

        if (first_cond == "RP") this.start_rp_set();
        else this.start_mat_set();

        this.start_time = Date.now();

        this.beforeUnloadHandler = () => {
            //console.log("before unload");
            this.abortAndSave();
            // Optionally, show a confirmation dialog
            // event.returnValue = 'Are you sure you want to leave?';
        };

        // Spara så att nästa session alltid är exakt DENNA + 1
        // oavsett om data sparats flera gånger innnan avslut.
        this.initial_session = session;

        window.addEventListener("beforeunload", this.beforeUnloadHandler);

        this.$refs.countDown1.play(
            () => {
                if (second_cond == "RP") this.start_rp_set();
                else this.start_mat_set();
            },
            0,
            pract_length,
            600,
            -65
        );
        this.$refs.countDown2.play(
            () => {
                //console.log("A Time up!");
                this.end_test();
            },
            pract_length,
            pract_length,
            600,
            280
        );

        //console.log(second_cond);
        //this.show_self_efficacy();
    },
};
</script>

<style lang="stylus">
.qtopic {
    cursor: default;
    margin-top: 10px;
    margin-bottom: 10px;
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 5px;
    padding-bottom: 10px;
    background-color: #00000011;
    border-radius: 20px;
    text-align: center;
    font-size: 20px;
    color: #FFFFFF;
    font-weight: bold;
    font-family: Arial, Helvetica, sans-serif;
}

.qbutton {
    cursor: pointer;
    font-family: serif;
    font-size: 20px;
    color: #000000;
    text-align: left;
    text-text-justify: auto;
    letter-spacing: 0.1em;
    display: inline-block;
    width: 200px;
    margin-top: 15px;
    margin-left: 200px;
    padding-top: 0.5em;
    padding-bottom: 0.5em;
    padding-left: 40px;
    padding-right: 40px;
    background-color: #FFFFFF55;
    border-radius: 20px;
    border: 4px solid white;
}
</style>
